/*
 * types/services/collection.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {CollectionCollectionBase} from './CollectionCollectionBase';

/**
 * The CollectionCreateCollectionRequest model module.
 * @module model/CollectionCreateCollectionRequest
 * @version version not set
 */
export class CollectionCreateCollectionRequest {
  /**
   * Constructs a new <code>CollectionCreateCollectionRequest</code>.
   * @alias module:model/CollectionCreateCollectionRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CollectionCreateCollectionRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CollectionCreateCollectionRequest} obj Optional instance to populate.
   * @return {module:model/CollectionCreateCollectionRequest} The populated <code>CollectionCreateCollectionRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CollectionCreateCollectionRequest();
      if (data.hasOwnProperty('collection'))
        obj.collection = CollectionCollectionBase.constructFromObject(data['collection']);
    }
    return obj;
  }
}

/**
 * @member {module:model/CollectionCollectionBase} collection
 */
CollectionCreateCollectionRequest.prototype.collection = undefined;


